<template>
  <div class="dashboard-item">
    <div class=" d-flex align-items-center dashboard-item__header">
      <h4 class="border-none m-0 p-0">New Leads</h4>
      <small-spinner v-if="ui.loading"/>
    </div>
    <div class="list">
      <div class="row">
        <div class="col-4">Lead</div>
        <div class="col-4">Source</div>
        <div class="col">Notes</div>
        <div class="col"></div>
      </div>
      <div class="dashboard-item__body scrollable" id="new-lead">
        <div class="row" v-for="(lead, index) in newLeads" :key="index">
          <div class="col-4 my-auto">
            <router-link :to="{ name: 'lead_info', params: { id: lead.uuid } }" class="lead-links">
              {{ lead.leads }}
            </router-link>
          </div>
          <div class="col-4 my-auto of-hidden">{{ lead.type }}</div>
          <div class="col-2 my-auto">
            <button @click="showNotes(lead.uuid, lead.leads)"
                    class="btn-note"
                    content="Show Notes" v-tippy="{ placement : 'bottom',  arrow: true }">
              <img src="@/assets/images/icons/icon-notes.svg" alt="Notes"/>
            </button>
          </div>
          <div class="col-2 text-right my-auto dsb-date">{{ lead.createdShort }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SmallSpinner from "../../../components/SmallSpinner";

export default {
  name: 'NewLeadsItems',
  components: {SmallSpinner},
  data() {
    return {
      newLeads: [],
      ui: {
        loading: false
      }
    }
  },
  beforeMount() {
    this.getNewLeads();
  },
  methods: {
    getNewLeads() {
      this.ui.loading = true
      this.$http
        .get('/api/v1/leads', {
          params: {
            status: 'New',
          },
        })
        .then((res) => (this.newLeads = res.data.data))
        .catch((err) => console.log(err))
        .finally(() => this.ui.loading = false)
    },
    showNotes(id, name) {
      this.$emit('showNotes', {id, name});
    }
  }
}
</script>
